// #region Imports
import React, { useEffect, useState } from 'react';
import useServicos from '../../hooks/useServicos';
import ServicosTable from '../../components/Servicos/ServicoTable/ServicosTable';
import ServicoCrud from '../../components/Servicos/ServicoCrud/ServicoCrud';
// #endregion

export default function ServicosPage() {
	// #region Hooks de dados
	const { listar, obter, criar, atualizar, remover, servicos, loading } = useServicos();
	// #endregion

	// #region Estado UI
	const [filters, setFilters] = useState({ q: '', categoria: 'TODAS' });
	const [page, setPage] = useState(1);
	const pageSize = 10;
	const [listState, setListState] = useState({ data: [], total: 0 });
	const [editingId, setEditingId] = useState(null);
	const [crudOpen, setCrudOpen] = useState(false);
	// #endregion

	// #region Efeitos
	useEffect(() => {
		setListState(listar({ ...filters, page, pageSize }));
	}, [listar, filters, page, pageSize]);
	// #endregion

	// #region Handlers
	function handleFiltersChange(next) { setFilters(next); setPage(1); }
	function handleCreate() { setEditingId(null); setCrudOpen(true); }
	function handleEdit(id) { setEditingId(id); setCrudOpen(true); }
	function handleDelete(id) { remover(id); setListState(listar({ ...filters, page, pageSize })); }
	function handleSave(payload) {
		if (editingId) { atualizar(editingId, payload); } else { criar(payload); }
		setListState(listar({ ...filters, page, pageSize }));
	}
	// #endregion

	// #region Derivados
	const editing = editingId ? obter(editingId) : null;
	const categorias = Array.from(new Set(servicos.map(s => s.categoria).filter(Boolean))).sort();
	// #endregion

	// #region Render
	return (
		<div className="servicos-page">
			<ServicosTable
				loading={loading}
				filters={filters}
				categorias={categorias}
				data={listState.data}
				total={listState.total}
				page={page}
				pageSize={pageSize}
				onFiltersChange={handleFiltersChange}
				onPageChange={p => setPage(p)}
				onCreate={handleCreate}
				onEdit={handleEdit}
				onDelete={handleDelete}
			/>
			<ServicoCrud
				open={crudOpen}
				servico={editing}
				onClose={() => setCrudOpen(false)}
				onSave={handleSave}
			/>
		</div>
	);
	// #endregion
}

